import React from 'react'
import HomeBanner from './HomeBanner'
import Divisions from './Divisions'
import HomeAbout from './HomeAbout'
import Specials from './Specials'

const Home = () => {
  return (
    <>
   
    <HomeBanner />
    <Divisions />
    {/* <Specials /> */}
    <HomeAbout />
    </>
  )
}

export default Home